import axios from '@/router/axios'
import BaseApi from '../base'

const path = '/admin/tenant'

// 设置解析辅助类
class SettingsParser {
  static parseSettings(tenantData) {
    let settings = { web: { titleStyle: {} }, mini: {}, mall: {} }
    try {
      settings = JSON.parse(tenantData.settings)
    } catch (error) {
      console.error('解析设置失败:', error)
    }

    return {
      ...settings,
      web: this.parseWebSettings(settings?.web, tenantData)
    }
  }

  static parseWebSettings(webSettings = {}, tenantData) {
    const { titleStyle, alias, fontSize, configs, rent } = webSettings

    return {
      titleStyle: this.parseTitleStyle(titleStyle),
      alias: alias || this.generateDefaultAlias(tenantData.name),
      fontSize: Number(fontSize) || 16,
      configs: this.parseConfigs(configs),
      rent: this.parseRentSettings(rent)
    }
  }

  static parseTitleStyle(titleStyle) {
    const defaultWebTitleStyle = {
      type: titleStyle || 'logoAndText',
      backGroundColor: '#1E90FF',
      fontColor: '#fff'
    }

    return titleStyle && typeof titleStyle === 'object' ? titleStyle : defaultWebTitleStyle
  }

  static generateDefaultAlias(name) {
    if (!name) return ''
    const reg = new RegExp('((.+(?<=市))|有限公司|有限责任公司)', 'g')
    return name.replace(reg, '')
  }

  static parseConfigs(configs = {}) {
    const defaultDepreciationRateRemark =
      '拆解配件成本单价需要计算折旧率，成本单价 = 拆解配件市场价 x 拆解配件折扣%'

    const defaultAssistantSharePerformanceRemark = '启用后销售员的绩效将被协助销售员代替'

    const defaultConfigs = {
      saleFundOccupationRate: { value: '1', remark: '' },
      depreciationRate: { value: '100', remark: defaultDepreciationRateRemark },
      showAveragePrice: { value: true, remark: '' },
      assistantSharePerformance: { value: false, remark: defaultAssistantSharePerformanceRemark }
    }

    return {
      saleFundOccupationRate: this.getConfigValue(
        configs,
        'saleFundOccupationRate',
        defaultConfigs
      ),
      depreciationRate: this.getConfigValue(configs, 'depreciationRate', defaultConfigs),
      showAveragePrice: this.getConfigValue(configs, 'showAveragePrice', defaultConfigs),
      assistantSharePerformance: this.getConfigValue(
        configs,
        'assistantSharePerformance',
        defaultConfigs
      )
    }
  }

  static getConfigValue(configs, prop, defaultConfigs) {
    return configs && configs[prop] && typeof configs[prop] === 'object'
      ? configs[prop]
      : defaultConfigs[prop]
  }

  static parseRentSettings(rent = {}) {
    return {
      billingCycle: rent && rent.billingCycle ? rent.billingCycle : 7,
      scopes: rent && rent.scopes && rent.scopes.length ? rent.scopes : []
    }
  }
}

export default class TenantApi extends BaseApi {
  constructor() {
    super(path)
  }
  static GetInstance = () => new TenantApi()

  getTenantInfo = async params => {
    const response = await this.get(`${path}/info`, params)
    const tenantData = response.data
    const parsedSettings = SettingsParser.parseSettings(tenantData)

    return {
      ...tenantData,
      logo: tenantData.logo || '/img/logo.svg',
      settings: parsedSettings
    }
  }

  updateTenantInfo = params => this.put(`${path}/update`, params)

  unregister = params => this.post(`${path}/unregister`, params)

  getChildren = params => this.get(`${path}/children`, params)

  getObj = params => this.get(`${path}`, params)

  // 清除业务数据
  clearBusinessData = tenantId => axios.delete(`${path}/clear-business-data/${tenantId}`)
}
